export default "__VITE_ASSET__7c8217ca__"